import _get from 'lodash/get';
import _castArray from 'lodash/castArray';

import { Base, Address, Customer, Fee, Invoice, Quotation, Attachments, JobUpdate, PaymentDetail } from '@/models';
import { toCamelCase, omitDeep } from '@/utilities';
import { EmailLog } from './emaillog.model';

export class Maintenancejob extends Base {
  public id: string;
  public office: string;
  public address: Address;
  public customer: Customer;
  public createdate: string;
  public targetdate: string;
  public inspector: string;
  public completiondate: string;
  public defectid: string;
  public status: string;
  public colourcode: string;
  public fees: Fee[];
  public emaillogs: EmailLog[];
  public ref: string;
  public quotation: Quotation;
  public invoice: Invoice;
  public attachments: Attachments;
  public quotationtoggle: boolean;
  public photos: string[];
  public updates: JobUpdate[];
  public payment: boolean;
  public paymentdetails: PaymentDetail[];
  /**
   * Constructor initialises the variables from the class Maintenancejob
   * @param data - the data to construct a type with all properties of <Maintenancejob>
   */
  public constructor(data?: Partial<Maintenancejob>) {
    super(data);
    data = toCamelCase(data);

    this.id = _get(data, 'id', '');
    this.office = _get(data, 'office', '');
    this.address = new Address(_get(data, 'address'));
    this.quotationtoggle = _get(data, 'quotationtoggle', false);
    this.customer = new Customer(_get(data, 'customer'));
    this.defectid = _get(data, 'defectid', '');
    this.inspector = _get(data, 'inspector', '');
    this.createdate = _get(data, 'createdate', '');
    this.targetdate = _get(data, 'targetdate', '');
    this.completiondate = _get(data, 'completiondate', '');
    this.status = _get(data, 'status', 'New');
    this.colourcode = _get(data, 'colourcode', '');
    this.quotation = new Quotation(_get(data, 'quotation'));
    this.emaillogs = _castArray(_get(data, 'emaillogs', [])).map((x: Partial<EmailLog>) => new EmailLog(x));
    this.ref = _get(data, 'ref', '');
    this.attachments = new Attachments(_get(data, 'attachments'));
    this.invoice = new Invoice(_get(data, 'invoice'));
    this.photos = _get(data, 'photos', []);
    this.updates = _castArray(_get(data, 'updates', [])).map((x: Partial<JobUpdate>) => new JobUpdate(x));
    this.payment = _get(data, 'payment', false);
    this.paymentdetails = _castArray(_get(data, 'paymentdetails', [])).map((x: Partial<PaymentDetail>) => new PaymentDetail(x));
  }

  /**
   * Convert class instance back into a plain old JSON object
   * and recursively remove all uuids we've add for Vue.
   *
   * @return {Object}
   */
  public toObject() {
    return omitDeep({ ...this }, ['_uuid']);
  }

  /**
  * Create a JSON representation of this object and it's descedents.
  *
  * @return {Object}
  */
  public toJSON() {
    const json = super.toJSON();
    // Convert the populated Client to the Client ID and handle fees conversion
    return {
      ...json,
      invoice: {
        ...this.invoice, // Ensure other invoice fields are preserved
        fees: this.invoice.fees.map(fee => fee.toJSON()), // Convert each Fee to JSON
      },
      customer: this.customer?.id,
      quotation: {
        ...this.quotation, // Ensure other invoice fields are preserved
        mics: this.quotation.mics.map(fee => fee.toJSON()), // Convert each Fee to JSON
        material: this.quotation.material.map(fee => fee.toJSON()), // Convert each Fee to JSON
        labour: this.quotation.labour.map(fee => fee.toJSON()), // Convert each Fee to JSON
      }
    };
  }


}
